import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-161f87f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"center","position":"absolute","bottom":"0","width":"100%","padding-bottom":"max(20px, env(safe-area-inset-bottom))","left":"0","right":"0"} }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","justify-content":"center","margin-top":"4px"} }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "21",
    y1: "12",
    x2: "9",
    y2: "12"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]

import { mainStore } from '@/stores/mainStore';
import { IonApp, IonLoading, IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonNote, IonRouterOutlet, IonItem, IonList, IonButton, IonIcon, menuController, useBackButton } from '@ionic/vue';
import tools from '@/composables/tools';
import { alquilerUiLog } from '@/composables/alquilerUiLog';
import router from '@/router';
import { currentUserStore } from '@/stores/currentUser'
import userAuth from './composables/userAuth';
import FloatingMessageIndicator from '@/components/FloatingMessageIndicator.vue';
import SupervisionBanner from '@/components/SupervisionBanner.vue';
import AvisoAppModal from '@/components/AvisoAppModal.vue';
import AppVersionOutdatedModal from '@/components/AppVersionOutdatedModal.vue';
import { useAvisoApp } from '@/composables/useAvisoApp';
import { configureNativeStatusBar } from '@/composables/useNativeStatusBar';
import { onMounted, ref } from 'vue';
import { trackMenuAccess } from '@/composables/menuUsage';
import {
  homeOutline,
  schoolOutline,
  calendarOutline,
  qrCodeOutline,
  chatbubblesOutline,
  businessOutline,
  walletOutline,
  warningOutline,
  cubeOutline,
  cashOutline,
  flashOutline,
  documentTextOutline,
  eyeOutline,
} from 'ionicons/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mainStoreInstance = mainStore();
const avisoApp = useAvisoApp();
const hasSupervisionBanner = ref(!!localStorage.getItem('supervision'));

useBackButton(10, () => {
  // Consume el atrás físico / WebView: no sale de la pantalla.
});

onMounted(() => {
  void configureNativeStatusBar();
  if (localStorage.getItem('token')) {
    avisoApp.startPolling();
  }
});

const closeMenu = async() => {
      await menuController.toggle();
}

const openSesiones = () => {
  tools().setLog('Abre lista de sesiones desde el menú');
  trackMenuAccess('clases');
  router.push({ name: 'Sesiones'})
  closeMenu();
};

const openHome = () => {
  tools().setLog('Abre inicio desde el menú');
  location.href = '/inicio';
  closeMenu();
};

const logout = async () => {
  await closeMenu();
  await userAuth().logout();
};

const openAlquileres = () => {
  alquilerUiLog('menu_abre_alquileres')
  trackMenuAccess('alquileres');
  location.href = '/alquileres'; //me da error si no lo hago asi.. .tengo q solucionarlo
};

const openSaldo = () => {
  tools().setLog('Abre la sección de saldo desde el menú');
  trackMenuAccess('mi_saldo');
  location.href = '/saldo';
  closeMenu();
};

const openEventos = () => {
  tools().setLog('Abre lista de eventos desde el menú');
  trackMenuAccess('eventos');
  location.href = '/eventos'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openMensajes = () => {
  tools().setLog('Abre lista de mensajes desde el menú');
  trackMenuAccess('mensajes');
  location.href = '/mensajes'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openIncidencias = () => {
  tools().setLog('Abre lista de incidencias desde el menú');
  trackMenuAccess('incidencias');
  location.href = '/Organizacion/incidencias'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openContarAsistentes = () => {
  tools().setLog('Abre contaje aleatorio de personas en sesión');
  trackMenuAccess('contar_personas');
  location.href = '/contar-asistentes';
  closeMenu();
};

const openQRScanner = () => {
  tools().setLog('Abre el escanner QR desde el menú');
  trackMenuAccess('lector_qr');
  location.href = 'https://escaner.gest.galidancia.com'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openDeteccionNecesidades = () => {
  tools().setLog('Abre formulario de detección de necesidades');
  location.href = '/necesidades'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openWhatsappLauncher = () => {
  tools().setLog('Abre el whatsapp launcher');
  location.href = '/whatsappLauncher'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Whatsapp Launcher' });
  closeMenu();
};

const openEntregas = () => {
  tools().setLog('Abre lista de entregas desde el menú');
  trackMenuAccess('entrega');
  router.push('/entrega');
  closeMenu();
};

const openDomotica = () => {
  tools().setLog('Abre la sección de domótica desde el menú');
  trackMenuAccess('domotica');
  location.href = '/domotica';
  closeMenu();
};

const openLiquidacion = () => {
  tools().setLog('Abre la sección de liquidación desde el menú');
  trackMenuAccess('liquidacion');
  location.href = '/liquidacion';
  closeMenu();
};

const openRecaudacion = () => {
  tools().setLog('Abre la sección de recaudación desde el menú');
  trackMenuAccess('recaudacion');
  location.href = '/recaudacion';
  closeMenu();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), {
    class: _normalizeClass({ 'has-supervision-banner': hasSupervisionBanner.value })
  }, {
    default: _withCtx(() => [
      _createVNode(SupervisionBanner),
      _createVNode(AvisoAppModal),
      _createVNode(AppVersionOutdatedModal),
      _createVNode(_unref(IonLoading), {
        "is-open": _unref(mainStoreInstance).$state.loading.show,
        message: _unref(mainStoreInstance).$state.loading.message
      }, null, 8, ["is-open", "message"]),
      _createVNode(_unref(IonMenu), { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Menu")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonContent), {
            class: "ion-padding",
            style: {"--padding-bottom":"max(60px, calc(env(safe-area-inset-bottom) + 60px))"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openHome
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(homeOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Inicio ")
                    ]),
                    _: 1
                  }),
                  (_unref(userAuth)().hasRole('coordinador de actividad') || _unref(userAuth)().hasRole('profesor'))
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 0,
                        button: "",
                        onClick: openSesiones
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(schoolOutline)
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Clases ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openEventos
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(calendarOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Eventos ")
                    ]),
                    _: 1
                  }),
                  (_unref(userAuth)().hasRole('coordinador de actividad'))
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 1,
                        button: "",
                        onClick: openQRScanner
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(qrCodeOutline)
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Lector QR ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openMensajes
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(chatbubblesOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Mensajes ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openAlquileres
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(businessOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Alquileres ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openSaldo
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(walletOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Mi Saldo ")
                    ]),
                    _: 1
                  }),
                  (_unref(userAuth)().hasRole('coordinador de actividad'))
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 2,
                        button: "",
                        onClick: openContarAsistentes
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(eyeOutline)
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Contar personas ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openIncidencias
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(warningOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Incidencias ")
                    ]),
                    _: 1
                  }),
                  (_unref(userAuth)().can('Buscar alumnos para Whatsapp Launcher'))
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 3,
                        button: "",
                        onClick: openWhatsappLauncher
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Lanzador de Whatsapps ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(userAuth)().can('Añadir deteccion de necesidades'))
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 4,
                        button: "",
                        onClick: openDeteccionNecesidades
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Detección de necesidades ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(userAuth)().hasRole('coordinador de actividad'))
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 5,
                        button: "",
                        onClick: openEntregas
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(cubeOutline)
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Entregas ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(userAuth)().hasRole('coordinador de actividad'))
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 6,
                        button: "",
                        onClick: openRecaudacion
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(cashOutline)
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Recaudación ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openDomotica
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(flashOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Domótica ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), {
                    button: "",
                    onClick: openLiquidacion
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(documentTextOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Liquidación ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(IonNote), { style: {"font-size":"smaller"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Versión " + _toDisplayString(require('../package.json').version), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(IonNote), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Hola, " + _toDisplayString(_unref(tools)().getShortName( _unref(currentUserStore)().user?.name || '')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(logout, ["prevent"]),
                    style: {"margin-left":"12px","color":"var(--ion-color-danger)","text-decoration":"none","display":"inline-flex","align-items":"center"}
                  }, _hoisted_5, 8, _hoisted_3)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonRouterOutlet), { id: "main-content" }),
      _createVNode(_unref(IonButton), {
        class: "home-shortcut-btn",
        fill: "solid",
        shape: "round",
        color: "light",
        onClick: openHome
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), { icon: _unref(homeOutline) }, null, 8, ["icon"])
        ]),
        _: 1
      }),
      _createVNode(FloatingMessageIndicator)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})